const loc_ru_strings = {
    "Login": {
        "HEADING": "Войти на MM-ID",
        "LOGIN": "Войти",
        "USER": "Пользователь",
        "PASSWORD": "Пароль",
        "LOGIN_FAIL": "Войти не удалось",
        "LOGIN_FIELD_REQUIRED": "Обязательно введите имя пользователя",
        "PASSWORD_FIELD_REQUIRED": "Обязательно введите пароль",
        "FORGOT_PASSWORD": "Забыли пароль?",
        "DIFFERENT_ACCOUNT": "Войти в другой аккаунт",
        "NO_ACCOUNT": "Нет аккаунта?",
        "REGISTER": "Зарегистрироваться на MMK",
        "CHANGE_DENIED_TEXT": "Вы можете сменить ваш пароль AD на Outlook Web Access или свяжитесь со службой поддержки."
    },
    "Dashboard": {
        "DASHBOARD_TEXT": "Панель управления",
        "ACTION_TEXT": "Действия",
        "CHANGE_PASSWORD_TEXT": "Сменить пароль",
        "MY_APPLICATIONS_TEXT": "Мои приложения MM",
        "APPLICATIONS_TEXT": "Приложения MM",
        "USERS_LIST_TEXT": "Управление пользователями"
    },
    "DashboardHome": {
        "ACTION_TEXT": "Панель управления",
        "MY_APPLICATIONS_TEXT": "Мои приложения MM",
        "APPLICATIONS_TEXT": "Приложения MM"
    },
    "Header": {
        "USER_MENU_TEXT": "Меню пользователя",
        "ACTION_TEXT": "Действия",
        "CHANGE_PASSWORD_TEXT": "Сменить пароль",
        "USERS_LIST_TEXT": "Управление пользователями",
        "USER_GROUPS": "Roles"
    },
    "Credentials": {
        "OLD_PASSWORD": "Старый пароль",
        "NEW_PASSWORD": "Новый пароль",
        "CONFIRM_PASSWORD": "Подтвердите пароль",
        "PASS_DO_NOT_MATCH": "Пароли не совпадают",
        "PASSWORD_FIELD_REQUIRED": "Поле \"Пароль\" обязательно для заполнения",
        "OLD_PASSWORD_FIELD_REQUIRED": "Поле \"Старый пароль\" обязательно для заполнения",
        "SUCCESS_TEXT": "Пароль был успешно изменен",
        "HEADING": "Сменить данные MM-ID",
        "HELP": "Нужна помощь?",
        "SAVE": "Изменить",
        "CANCEL": "Отменить",
        "PASSWORD_CHANGE_ERROR": "Не удалось сохранить данные. Повторите попытку позже",
        "PASSWORD_CHANGE_LINK_EXPIRED": "The password reset link is invalid or has expired. Please, request a new link.",
        "PASSWORD_STREIGHT_ERROR": "Пароль должен содержать не менее 10 символов (симв. нижнего и верхнего регистров, спец.символы и цифры)",
        "PASSWORD_REQUIREMENTS_TEXT": "Пароль должен соответствовать следующим требованиям:",
        "LOWERCASE_LETTER_TEXT": "Минимум одна буква",
        "UPPERCASE_LETTER_TEXT": "Минимум одна буква верхнего регистра",
        "NUMBER_TEXT": "Минимум одна цифра",
        "SPECIAL_SYMBOL_TEXT": "Минимум один специальный символ",
        "PASSWORD_LENGTH_TEXT": "Содержать не менее 10 символов",
        "PASSWORD_RESTRICTION_TEXT": "Имя, фамилия и имя пользователя не должны быть частью пароля",
        "CHANGE_PASSWORD_TEXT": "Сменить пароль",
        "ACTION_TEXT": "Действия",
        "CHANGE_DENIED_TEXT": "Вы можете сменить ваш пароль AD на Outlook Web Access или свяжитесь со службой поддержки."
    },
    "CreatePassword": {
        "PASSWORD": "Создайте пароль",
        "CONFIRM_PASSWORD": "Подтвердите пароль",
        "PASS_DO_NOT_MATCH": "Пароли не совпадают",
        "PASSWORD_FIELD_REQUIRED": "Поле \"Пароль\" обязательно для заполнения",
        "SUCCESS_TEXT": "Данные были успешно изменены",
        "HEADING": "Создайте пароль",
        "HELP": "Нужна помощь?",
        "SAVE": "Изменить",
        "CANCEL": "Отменить",
        "PASSWORD_CHANGE_ERROR": "Не удалось сохранить данные. Повторите попытку позже",
        "PASSWORD_CHANGE_LINK_EXPIRED": "The password reset link is invalid or has expired. Please, request a new link.",
        "PASSWORD_STREIGHT_ERROR": "Пароль должен содержать не менее 10 символов (симв. нижнего и верхнего регистров, спец.символы и цифры)",
        "PASSWORD_REQUIREMENTS_TEXT": "Пароль должен соответствовать следующим требованиям:",
        "LOWERCASE_LETTER_TEXT": "Минимум одна буква",
        "UPPERCASE_LETTER_TEXT": "Минимум одна буква верхнего регистра",
        "NUMBER_TEXT": "Минимум одна цифра",
        "SPECIAL_SYMBOL_TEXT": "Минимум один специальный символ",
        "PASSWORD_LENGTH_TEXT": "Содержать не менее 10 символов",
        "PASSWORD_RESTRICTION_TEXT": "Имя, фамилия и имя пользователя не должны быть частью пароля",
        "PASSWORD_WAS_SET": "Ссылка уже использовалась для создания пароля. Если вы не помните пароль, воспользуйтесь функцией смены пароля.",
        "OLD_PASSWORD_REQUIRED": "Поле \"Старый пароль\" обязательно для заполнения",
        "MMID_CHANGE_PASSWORD": "Сменить пароль",
        "OLD_PASSWORD": "Старый пароль",
        "INVALID_OLD_PASSWORD": "Старый пароль неправильный",
        "USER_NOT_FOUND_OR_INACTIVE": "Пользователь не найден или он неактивен",
        "UNKNOWN_ERROR": "Произошла ошибка при смене пароля"
    },
    "ForgotPassword": {
        "USER": "Адрес эл.почты",
        "LOGIN_FAIL": "Введите правильный адрес эл.почты",
        "LOGIN_FIELD_REQUIRED": "Поле \"Адрес эл.почты\" обязательно для заполнения",
        "HEADING": "Не помню пароль",
        "HELP": "Нужна помощь?",
        "SAVE": "Отправить инструкции по смене пароля",
        "CANCEL": "Отменить",
        "SUCCESS_TEXT": "Проверьте почту, вы должны были получить наше письмо.",
        "CHANGE_DENIED_TEXT": "Вы можете сменить ваш пароль AD на Outlook Web Access или свяжитесь со службой поддержки.",
        "PASSWORD_RESET_TOO_OFTEN": "Функция смены пароля использовалась слишком часто. Повторите попытку позже",
        "RESET_FAILED": "Не удалось войти",
        "LINK_EXPIRED": "Срок действия вашей ссылки для входа в систему истек. Введите ваш адрес электронной почты для повторного получения ссылки для входа в систему.",
        "HEADING_EXPIRED": "Срок действия вашей ссылки для входа в систему истек",
        "SAVE_EXPIRED": "Направить запрос на получение ссылки для входа в систему"
    },
    "UsersList": {
        "USERS_LIST_TEXT": "Управление пользователями",
        "ACTIVE": "Активен",
        "INACTIVE": "Неактивен",
        "MMID": "MMID",
        "EXTRANET": "Внешние пользователи",
        "OU": "Организационная единица",
        "ORGANIZATION_UNIT": "Организационная единица",
        "LANGUAGE": "Язык",
        "OPEN_FILTER": "Открыть фильтр",
        "CLOSE_FILTER": "Закрыть фильтр",
        "RESET": "сбросить",
        "RESET_ALL_FILTERS": "Сбросить все фильтры",
        "SEARCH": "Поиск",
        "STATUS": "Состояние",
        "GROUPS": "Группы",
        "SHOW_ALL_DETAILS": "Показать все детали",
        "SHOW_LESS": "Скрыть",
        "ASCENDING": "По возрастанию",
        "DESCENDING": "По убыванию",
        "LIST_END": "Конец списка",
        "SORT_BY_LASTNAME": "Сортировать по фамилии",
        "SORT_BY_FIRSTNAME": "Сортировать по имени",
        "SORT_BY_EMAIL": "Сортировать по адресу эл.почты",
        "SORT_BY_LANGUAGE": "Сортировать по языку",
        "SORT_BY_STATUS": "Сортировать по статусу",
        "SORT_BY_OU": "Сортировать по ОЕ",
        "SORT_BY_ACCOUNT_NAME": "Sort by Logon Name",
        "EDIT": "Изменить",
        "CREATE": "Новый пользователь",
        "DIGICREATE": "Новый пользователь MM digital",
        "EXTRANETCREATE": "Новый пользователь MM SharePoint Extranet",
        "MMPCREATE": "Новый пользователь MMP digital",
        "ACTIVATE": "Активировать",
        "DEACTIVATE": "Деактивировать",
        "USER_WAS_ACTIVATED": "Пользователь активирован",
        "USER_WAS_DEACTIVATED": "Пользователь деактивирован",
        "ERROR_USER_ACTIVATION": "При активации произошла ошибка",
        "ERROR_USER_DEACTIVATION": "При деактивации произошла ошибка",
        "SEND_FORGOT_PW_EMAIL": "Отправить инструкции по смене пароля",
        "SEND_FORGOT_PW_EMAIL_GENERIC": "Стандартные инструкции по смене пароля",
        "SEND_FORGOT_PW_EMAIL_DIGI": "Инструкции по смене пароля MM digital",
        "SEND_FORGOT_PW_EMAIL_MMP": "Инструкции по смене пароля MMP digital",
        "SEND_FORGOT_PW_EMAIL_EXTRANET": "Инструкции по смене пароля SP",
        "COMPANY": "Компания",
        "SEND_WELCOME_EMAIL": "Отправлять приветственное письмо",
        "SEND_WELCOME_EMAIL_DIGI": "Приветственное письмо MM digital",
        "SEND_WELCOME_EMAIL_DIGI_NO_PASS": "Приветственное письмо MM digital без кнопки пароля",
        "SEND_WELCOME_EMAIL_MMP": "Приветственное письмо MMP digital",
        "SEND_WELCOME_EMAIL_MMP_NO_PASS": "Приветственное письмо MMP digital без кнопки пароля",
        "SEND_WELCOME_EMAIL_EXTRANET": "Приветственное письмо SP",
        "SEND_WELCOME_EMAIL_EXTRANET_NO_PASS": "Приветственное письмо SP без кнопки пароля",
        "APPLY_FILTER_FOR_USERS": "Воспользуйтесь фильтрами или функцией поиска для вывода результатов",
        "GENERATING_EMAIL": "Создание электронной почты ....",
        "ERROR_EMAIL_GENERATE": "Ошибка при генерации электронной почты ....",
        "LOCKED": "Locked",
        "UNLOCK": "Unlock",
        "SET_PASSWORD": "Set password",
        "PHYSICAL_LOCATION": "Location",
        "REQUIRED": "Required",
        "USER_TYPE": "User type",
        "CANONICAL_NAME": "Canonical name"
    },
    "EditUser": {
        "USERS_LIST_TEXT": "Управление пользователями",
        "USER_WAS_ACTIVATED": "Пользователь активирован",
        "USER_WAS_DEACTIVATED": "Пользователь деактивирован",
        "ERROR_USER_ACTIVATION": "При активации произошла ошибка",
        "ERROR_USER_DEACTIVATION": "При деактивации произошла ошибка",
        "LOADING_USER_ERROR": "Загрузка ошибки пользователя",
        "FIRSTNAME": "Имя",
        "LASTNAME": "Фамилия",
        "EMAIL": "Адрес эл.почты",
        "ACCOUNT_NAME": "Логин пользователя (до Windows 2000)",
        "LANGUAGE": "Язык",
        "PRINCIPAL_NAME": "Имя участника-пользователя",
        "OU": "Организационная единица",
        "CLASS_DISPLAY_NAME": "Отображаемое имя",
        "PHONE": "Телефон",
        "WEBSITE": "Веб-сайт",
        "COUNTRY": "Страна",
        "STATE": "Штат/область",
        "LOCATION": "Город",
        "STREET": "Улица",
        "POSTAL_CODE": "Почтовый индекс",
        "COMPANY": "Компания",
        "DEPARTMENT": "Отдел",
        "PERSONAL_TITLE": "Должность",
        "MANAGER": "Управляющий",
        "DESCRIPTION": "Описание",
        "GROUPS": "Группы",
        "SAVE": "Сохранить",
        "CANCEL": "Отменить",
        "USER_STATUS": "Статус пользователя",
        "ACTIVE": "Активен",
        "INACTIVE": "Неактивен",
        "ACTIVATE": "Активировать",
        "DEACTIVATE": "Деактивировать",
        "USER_WAS_SAVED": "Пользователь сохранен",
        "UNKNOWN_ERROR": "При сохранении пользователя произошла неизвестная ошибка",
        "PROXY_ADDRESSES": "Прокси-адреса",
        "BROWSE": "Обзор",
        "REMOVE": "Удалить",
        "ONLY_JPG": "Поддерживаются только изображения в формате jpg!",
        "FILE_SIZE": "Размер файла не должен превышать 100 Кб!",
        "DIMENSIONS": "Максимально допустимые масштабы изображения: 96х96 пикселей",
        "SEND_FORGOT_PW_EMAIL": "Отправить инструкции по смене пароля",
        "SEND_FORGOT_PW_EMAIL_GENERIC": "Стандартные инструкции по смене пароля",
        "SEND_FORGOT_PW_EMAIL_DIGI": "Инструкции по смене пароля MM digital",
        "SEND_FORGOT_PW_EMAIL_MMP": "Инструкции по смене пароля MMP digital",
        "SEND_FORGOT_PW_EMAIL_EXTRANET": "Инструкции по смене пароля SP",
        "VIRUS_FOUND": "Сохранить пользователя не удалось. В прикрепленном файле найдена вредоносная программа. Файл не будет загружен. Свяжитесь с системным администратором.",
        "VIRUS_SCANNER_NOT_AVL": "Не удалось проверить файл на наличие вредоносных программ. Повторите попытку позже. Свяжитесь с системным администратором, если проблема не решится.",
        "INFO": "Сведения:",
        "SEND_WELCOME_EMAIL": "Отправлять приветственное письмо",
        "SEND_WELCOME_EMAIL_DIGI": "Приветственное письмо MM digital",
        "SEND_WELCOME_EMAIL_DIGI_NO_PASS": "Приветственное письмо MM digital без кнопки пароля",
        "SEND_WELCOME_EMAIL_MMP": "Приветственное письмо MMP digital",
        "SEND_WELCOME_EMAIL_MMP_NO_PASS": "Приветственное письмо MMP digital без кнопки пароля",
        "SEND_WELCOME_EMAIL_EXTRANET": "Приветственное письмо SP",
        "SEND_WELCOME_EMAIL_EXTRANET_NO_PASS": "Приветственное письмо SP без кнопки пароля",
        "SAVING_USER_SPINNER": "Сохраняем данные пользователя, подождите",
        "DUPLICATE_USER": "Такой пользователь уже есть",
        "GENERATING_EMAIL": "Создание электронной почты ....",
        "ERROR_EMAIL_GENERATE": "Ошибка при генерации электронной почты ....",
        "UNLOCK": "Unlock",
        "SET_PASSWORD": "Set password",
        "COST_CENTER": "Cost center",
        "JOB_TITLE": "Job title",
        "GENDER": "Gender",
        "USER_NOT_FOUND": "Пользователь не найден",
        "USER_TYPE": "User type",
        "CANONICAL_NAME": "Canonical name"
    },
    "ResendWelcome": {
        "GENERATING_EMAIL": "Создание приветственного сообщения электронной почты ...."
    },
    "Shared": {
        "USER_WAS_ACTIVATED": "Пользователь активирован",
        "USER_WAS_DEACTIVATED": "Пользователь деактивирован",
        "ERROR_USER_ACTIVATION": "При активации произошла ошибка",
        "ERROR_USER_DEACTIVATION": "При деактивации произошла ошибка",
        "EMAIL_WAS_SENT": "Письмо было успешно отправлено",
        "EMAIL_NOT_SENT_USER_ACTIVE": "Письмо не было отправлено. Пользователь уже активирован. Воспользуйтесь функцией отправки инструкций по смене пароля",
        "ERROR_EMAIL_SEND": "Ошибка при отправке письма",
        "EMAIL_NOT_SENT_USER_INACTIVE": "Письмо не было отправлено. Пользователь неактивен. Воспользуйтесь функцией отправки письма для регистрации на MM digital",
        "PASSWORD_RESET_TOO_OFTEN": "Функция смены пароля использовалась слишком часто. Повторите попытку позже",
        "USER_WAS_UNLOCKED": "User was unlocked",
        "ERROR_UNLOCK_USER": "Error unlocking user"
    }
};

export default loc_ru_strings;



// WEBPACK FOOTER //
// ./src/resources/ru.js